<template>
  <div class="home">
<!--
    <div class="titletext">Thomas Maniero</div>
-->

    <div ref="secstart" class="paratext" style="height:100vh; display:flex; justify-content:center; align-items:center;">
      <v-flex xs10 sm8 lg6><v-layout align-center justify-center column fill-height>

        <span class="titletext">Thomas Maniero</span>
        <span class="paratextbold">Resume</span>
        <span class="paratext">eMail: <a href="mailto:thomas@maniero.info">thomas@maniero.info</a></span>
        <span class="paratext">Linkedin: <a href="http://it.linkedin.com/pub/thomas-maniero/8/593/586"><img src="http://www.linkedin.com/img/webpromo/btn_in_20x15.png" width="20" height="15" alt="view my LinkedIn profile" style="vertical-align:middle" border="0">view my profile</a></span>
        <span class="paratext">Download: <a href="/Thomas_Maniero_Resume.pdf">PDF version</a></span>

      </v-layout></v-flex>
    </div>

    <div v-for="info in infos" :key=info.id     
        class="paratext" 
        :style="{ opacity: info.opacity, height: info.height+'vh', display:'flex', 'justify-content':'center', 'align-items':'center' }"
        v-waypoint="{ active: (info.onWaypoint !== null), callback: info.onWaypoint, options: {threshold: fullThreshold } }">
      <v-flex xs10 sm8 lg6><v-layout align-center justify-center row fill-height>

        <table :ref="'table'+info.id" width="100%">
        <tr v-if="info.sectionTitle" bgcolor=#330000>
          <td>
            <span style="color: #FFFFFF;" class="normaltextbold">{{info.sectionTitle}}</span>
          </td>
        </tr>
        <tr>
          <td>
            <br/>

            <div v-if="info.job" class="normaltextbold">
              <div >{{info.job.title}}</div>
              <div v-html="info.job.company"></div>
              <div v-if="info.job.where">{{info.job.where}}</div>
              <div>{{info.job.time}}</div>
            </div>

            <ul :style="info.job ? 'margin-top: 0.8em;' : 'margin-top: 0; padding-left: 2.0em;'">
              <li v-for="skill in info.skills" :key="skill" style="margin-bottom: 0.5em;">
                <div class="normaltext" v-html="skill"></div>
              </li>
            </ul>
          </td>
        </tr>
        </table>

      </v-layout></v-flex>
    </div>

    <div ref="secend" class="paratext" style="height:40vh; display:flex; justify-content:center; align-items:center;">
      <v-flex xs10 sm8 lg6><v-layout align-center justify-center row fill-height>

      </v-layout></v-flex>
    </div>

   </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    HelloWorld
  },

  data() {
    return {
      scrollTime: 0,
      animId: -1,
      viewedElemId: -1,

      enableOpacityDivAnim: true,

      scrollThreshold: 0.02, // screen height percent
      scrollThresholdLast: -100,

      fullThreshold: [],
      infos: [
        {
          id: 0,
          parent: this,
          image: "team.png",
          height: 1,
          opacity: 1,
          sectionTitle: `Management Skills:`,
          job: null,
          skills: [
            `Experienced in the coordination of planning and developing schedule for both software and hardware.`,
            `Experienced in the coordination and supervising of outsourced software development.`,
            `Experienced in the supervising of the team dedicated to UI design and software graphics requirements.`,
          ],
          /*onWaypoint: function({el, going, direction, _entry}) {
            //console.log("0) " + _entry.intersectionRatio);
            console.log("0) wh " + window.innerHeight);
            let r = _entry.boundingClientRect;
            console.log("0) bw " + r.height);

            let y = r.y + r.height/2;
            let id = y / window.innerHeight;
            console.log("0) i " + id);
          },*/
          onWaypoint: null,
          onScroll: function(el, factor) {
            this.opacity = this.parent.defaultScrollOpacity(factor);
          },
        },

        {
          id: 1,
          parent: this,
          image: "tech.png",
          height: 1,
          opacity: 1,
          sectionTitle: `Technical Skills:`,
          job: null,
          skills: [
            `Experienced in procedural and object oriented programming.`,
            `Experienced in UI design and graphics and sound programming on console, mobile, web and embedded platforms.`,
            `Excellent knowledge of microcontroller platforms and Linux embedded hardware and software ecosystems.`,
            `Excellent knowledge of many programming languages such as C/C++, C#, Java, Javascript, Typescript, Python and x86 and ARM assembly.`,
            `Excellent knowledge of many IDE, software frameworks and database software.`,
          ],
          onWaypoint: null,
          onScroll: function(el, factor) {
            this.opacity = this.parent.defaultScrollOpacity(factor);
          },
        },

        {
          id: 2,
          parent: this,
          image: "corona.png",
          height: 1,
          opacity: 1,
          sectionTitle: `Professional Experience:`,
          job: {
            title: `Senior Software Developer`,
            company: `<a href='https://www.inventia.biz/' target='_blank'>Inventia, a CRIF company</a>`,
            where: `Milano, Italy`,
            time: `2019, present`
          },
          skills: [
            `Coordination of the image analysis team for R&D new solutions for the core detection processes of the product.`,
            `Refactor the image analysis pipeline with focus on performance and maintainability.`,
            `Definition of targets and technical requirements for the internal software used for image analysis development.`
          ],
          onWaypoint: null,
          onScroll: function(el, factor) {
            this.opacity = this.parent.defaultScrollOpacity(factor);
          },
        },

        {
          id: 3,
          parent: this,
          image: "oven2.png",
          height: 1,
          opacity: 1,
          sectionTitle: null,
          job: {
            title: `Technical Lead and Lead Programmer`,
            company: `<a href='https://www.piron.it/' target='_blank'>Piron srl</a>`,
            where: `Padova, Italy`,
            time: `2014, 2019`
          },
          skills: [
            `Coordination of the software/hardware team which developed a new product line of high technological professional cooking ovens, named <a href='https://www.piron.it/explora' target='_blank'>Explora</a>, employing Industry 4.0 solutions.`,
            `Design and development of the control board firmware based on <a href='https://www.st.com/en/microcontrollers-microprocessors/stm32f373.html' target='_blank'>STM32 microcontroller</a>.`,
            `Design and development of the UI software, with <a href='https://www.qt.io/' target='_blank'>Qt framework</a>, working on Linux embedded board.`,
          ],
          onWaypoint: null,
          onScroll: function(el, factor) {
            this.opacity = this.parent.defaultScrollOpacity(factor);
          },
        },

        {
          id: 4,
          parent: this,
          image: "engine.png",
          height: 1,
          opacity: 1,
          sectionTitle: null,
          job: {
            title: `Senior Engine and Game Programmer`,
            company: `<a href='http://www.xplored.com/eng/' target='_blank'>Xplored</a>`,
            where: `Rapallo, Italy`,
            time: `2013, 2014`
          },
          skills: [
            `Work on the in-house cross-platform graphics engine, 
            re-writing of the flash port using the latest flascc compiler, 
            flash audio code enhancement, finalization of the port to flash of various mobile games.`,
          ],
          onWaypoint: null,
          onScroll: function(el, factor) {
            this.opacity = this.parent.defaultScrollOpacity(factor);
          },
        },

        {
          id: 5,
          parent: this,
          image: "mobile.png",
          height: 1,
          opacity: 1,
          sectionTitle: null,
          job: {
            title: `Lead Programmer and Engine Programmer`,
            company: `<a href='https://www.mobygames.com/company/frame-studios-srl' target='_blank'>Frame Studios Interactive</a>`,
            where: `Belluno, Italy`,
            time: `2011, 2012`
          },
          skills: [
            `Design and development of <a href='https://www.nintendo.com/games/detail/gem-smashers-3ds' target='_blank'>Gem Smashers 3D</a> for Nintendo 3DS; this was a completely new version optimized for the stereoscopic dual screen of the console.`,
            `Development of an optimized version of the Gem Smashers 3D Mobile's engine for Risk City, a Windows game for the Museo del Risparmio in Torino - Italy.`,
          ],
          onWaypoint: null,
          onScroll: function(el, factor) {
            this.opacity = this.parent.defaultScrollOpacity(factor);
          },
        },

        {
          id: 6,
          parent: this,
          image: "music.png",
          height: 1,
          opacity: 1,
          sectionTitle: null,
          job: {
            title: `Contractual Works`,
            company: `Indie mobile developers`,
            where: null,
            time: `2010, 2011`
          },
          skills: [
            `Work on customized version of my <a href='http://www.shlzero.com/wordpress/?page_id=170' target='_blank'>Hekkus Sound System</a> library for Indie developers around the world, porting it on new platforms like Samsung Bada OS, Android and iOS.`,
          ],
          onWaypoint: null,
          onScroll: function(el, factor) {
            this.opacity = this.parent.defaultScrollOpacity(factor);
          },
        },

        {
          id: 7,
          parent: this,
          image: "gamepad.png",
          height: 1,
          opacity: 1,
          sectionTitle: null,
          job: {
            title: `Game Programmer and Engine Programmer`,
            company: `<a href='https://www.mobygames.com/company/frame-studios-srl' target='_blank'>Frame Studios Interactive</a>`,
            where: `Belluno, Italy`,
            time: `2005, 2010`
          },
          skills: [
            `Work on seven Nintendo DS/DSi shipped titles: Princess Natasha, M&M's: Break'Em, The Aly & AJ Adventure, Shining Stars: Super Starcade, Smiley World Island Challenge,
			      Amici DS, JIGAPIX DS and DSi.`,
            `Design and development of the in-house Graphics Engine and WiFi connectivity system.`,
          ],
          onWaypoint: null,
          onScroll: function(el, factor) {
            this.opacity = this.parent.defaultScrollOpacity(factor);
          },
        },

        {
          id: 8,
          parent: this,
          image: "pacghost.png",
          height: 1,
          opacity: 1,
          sectionTitle: null,
          job: {
            title: `Game Designer and Game Programmer`,
            company: `Quick Solution SRL`,
            where: `Padova, Italy`,
            time: `2002, 2003`
          },
          skills: [
            `Design and implementation of a shareware Pocket-PC game named <a href='http://www.shlzero.com/downloads/older/rc/rc_ppc_1_x2.jpg' target='_blank'>Rainy Colors</a>.`,
            `Development of a Graphics and Sound framework with cross platform capabilities (Windows PC/Pocket-PC) to speed up coding and debugging process.`,
          ],
          onWaypoint: null,
          onScroll: function(el, factor) {
            this.opacity = this.parent.defaultScrollOpacity(factor);
          },
        },

        {
          id: 9,
          parent: this,
          image: "dbase.png",
          height: 1,
          opacity: 1,
          sectionTitle: null,
          job: {
            title: `Database and User Interface Programmer`,
            company: `<a href='https://www.ibc.it/' target='_blank'>IBC SRL</a>`,
            where: `Padova, Italy`,
            time: `2000, 2001`
          },
          skills: [
            `Implementation of custom input interfaces for in-house supermarket management software.`,
            `Customer service support.`,
          ],
          onWaypoint: null,
          onScroll: function(el, factor) {
            this.opacity = this.parent.defaultScrollOpacity(factor);
          },
        },

      ]

    }
  },

  methods: {
    updateInfosHeight() {
      let enableOpacityDivAnim = true;
      let screenWidth = this.getScreenWidth();
      //console.log('**wh' + window.innerHeight);
      for (let i = 0; i < this.infos.length; ++i) {
        let el = this.$refs['table'+i][0];
        if (el) {
          //console.log(el.scrollHeight);
          // calc p as the percentage of the table on the screen
          let w = screenWidth;
          let diff = w - el.scrollHeight;
          let p = (100*diff) / w;
          let dp = 100-p;
          // set height of the table plus 40vh (20vh top and 20vh bottom margins)
          this.infos[i].height = 40 + dp;

          // check, avoid opacity div anim if element bigger than screen height
          if (el.offsetHeight > screenWidth)
            enableOpacityDivAnim = false;
        }
      }

      // update
      this.enableOpacityDivAnim = enableOpacityDivAnim;
    },

    getScreenWidth() {
      return (window.isMobile) ? document.getElementById("inspire").offsetHeight : window.innerHeight;
    },

    onresize() {
      this.updateInfosHeight();
      this.onscroll();
    },

    onscroll() {
      this.scrollTime = 0;

      let scrolldom = (window.isMobile) ? document.getElementById("inspire") : window;
      let stop = scrolldom.scrollY;
      let screenWidth = this.getScreenWidth();

      // avoid continuous calc
      if (Math.abs(this.scrollThresholdLast - stop) < (this.scrollThreshold * screenWidth))
        return;
      this.scrollThresholdLast = stop;

      for (let i = 0; i < this.infos.length; ++i) {
        let el = this.$refs['table'+i][0];
        if (!el)
          continue;
        let f = 0;
        let elr = el.getBoundingClientRect();
        //console.log(i + ") " + elr.top + " " + elr.bottom);
        if (elr.bottom < 0)
          f = 0;
        else if (elr.top >= screenWidth)
          f = 1;
        else {
          let middley = (elr.top + el.offsetHeight/2);
          f = (middley / screenWidth);
          if (f < 0) f = 0;
          if (f > 1) f = 1;
          //console.log(i + ") " + middley + " " + screenWidth);

          if ((f > 0.3) && (f < 0.7))
            this.viewedElemId = i;
        }

        if (typeof this.infos[i]._lastF === "undefined")
          this.infos[i]._lastF = 0;

        let df = Math.abs(this.infos[i]._lastF - f);
        if ((df >= 0.05) 
            || ((f == 0) && (this.infos[i]._lastF != 0))
            || ((f == 1) && (this.infos[i]._lastF != 1))) {

          this.infos[i]._lastF = f;
          this.infos[i].onScroll(el, f);
        }
      }
    },

    defaultScrollOpacity(factor) {
      if (!this.enableOpacityDivAnim)
        return 1.0;
      let opacity = Math.sin(factor*Math.PI)*1.6;
      return Math.max(0, Math.min(opacity, 1));
    },

    updateComponent() {
      this.scrollTime += 250/1000;

      if ((this.viewedElemId >= 0) && (this.viewedElemId < this.infos.length)) {
        let info = this.infos[this.viewedElemId];

        if ((this.scrollTime >= 1.0) && (info.opacity >= 0.7) && (info.id != this.animId)) {
          this.animId = info.id;
          this.$bgscene.changeAnimation(info.image);
        }
      }
    },

  },

  beforeMount() {
    //console.log("mounted " + window.isMobile);
    for (let i = 0; i <= 1.0; i += 0.01) {
      this.fullThreshold.push(i);
    }   
  },

  mounted() {
    window.addEventListener("resize", this.onresize.bind(this), false);
    let scrolldom = (window.isMobile) ? document.getElementById("inspire") : window;
    scrolldom.addEventListener("scroll", this.onscroll.bind(this));
    this.interval = setInterval(this.updateComponent.bind(this), 250);  

    this.onresize();
    this.$bgscene.doAnimateFirst();
  },

  beforeDestroy: function() {
    window.removeEventListener("resize", this.onresize.bind(this), false);
    let scrolldom = (window.isMobile) ? document.getElementById("inspire") : window;
    scrolldom.removeEventListener("scroll", this.onscroll.bind(this));
    clearInterval(this.interval); 
  }

}
</script>

<style scoped lang="scss">
.titletext {
  font-size: 2.5em;
  font-weight: bold;
  color: black;
  margin-top: 0.7em;
  margin-left: 0.7em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.paratext {
  font-size: 1.7em;
  font-weight: normal;
  color: black;
  margin-top: 0.7em;
  margin-left: 0.7em;
}

.paratextbold {
  @extend .paratext;
  font-weight: bold;
}

.normaltext {
  font-size: 1.7em;
  font-weight: normal;
  color: black;
}

.normaltextbold {
  @extend .normaltext;
  font-weight: bold;
}

.smalltext {
  font-size: 1.4em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
